import { Link as RouterLink } from 'react-router-dom'
import { useBureauParent } from '../api/queries'
import { BureauParentBadge, type BureauParentBadgeProps } from '../usecases/BureauParentBadge'

interface BureauParentBadgeFactoryProps {
  customerId: string
}

const Link: BureauParentBadgeProps['Link'] = ({ to, children }) => <RouterLink to={to}>{children}</RouterLink>

export const BureauParentBadgeFactory = ({ customerId }: BureauParentBadgeFactoryProps) => {
  const { data: bureauParent } = useBureauParent(customerId)

  return <BureauParentBadge bureau={bureauParent} Link={Link} />
}
